export const loyalityCardCustomLimit = (limit,count) => {

    if(limit == null){
        return true
    }else if (limit != null && count <= limit ){
        return true
    }else{
        return false
    }
};